export var MODAL_CONTAINER_ID = "ws-modal-container";
